import { Container } from "@/components/ui/container";
import { TrendingUp, AlertTriangle, DollarSign, Target } from "lucide-react";

export const CFOChallengeSection = () => {
  const challenges = [
    {
      icon: TrendingUp,
      title: "Rising IT & security budgets without clear ROI",
      description: "Year-over-year increases in technology spend with limited visibility into actual business value"
    },
    {
      icon: AlertTriangle,
      title: "Redundant tools purchased out of 'fear' or urgency",
      description: "Panic buying during security incidents leading to overlapping solutions and vendor sprawl"
    },
    {
      icon: DollarSign,
      title: "Underused Microsoft 365 and security features already paid for",
      description: "Paying for enterprise licenses while using basic functionality and buying third-party alternatives"
    },
    {
      icon: Target,
      title: "CFO accountability for cost containment",
      description: "Board pressure to optimize spending while maintaining security and compliance requirements"
    }
  ];

  return (
    <section className="py-16 md:py-24 bg-white">
      <Container>
        <div className="text-center mb-12">
          <div className="inline-block px-4 py-2 bg-red-100 rounded-full text-red-700 font-medium text-sm mb-4">
            The CFO's Challenge
          </div>
          <h2 className="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl mb-6">
            IT spend keeps rising, but value doesn't always keep pace
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            CFOs are asked to approve budgets for new tools every year—yet many organizations are already paying for overlapping or underutilized technology.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 max-w-6xl mx-auto">
          {challenges.map((challenge, index) => {
            const IconComponent = challenge.icon;
            return (
              <div key={index} className="bg-gray-50 rounded-xl p-6 border border-gray-200">
                <div className="flex items-start space-x-4">
                  <div className="bg-red-100 rounded-lg p-3 flex-shrink-0">
                    <IconComponent className="h-6 w-6 text-red-600" />
                  </div>
                  <div>
                    <h3 className="font-semibold text-gray-900 mb-2">{challenge.title}</h3>
                    <p className="text-gray-600">{challenge.description}</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        {/* Impact Statement */}
        <div className="mt-12 bg-gradient-to-r from-red-50 to-orange-50 rounded-2xl p-8 text-center border border-red-100">
          <h3 className="text-2xl font-bold text-gray-900 mb-4">
            The Hidden Cost of Tool Sprawl
          </h3>
          <p className="text-lg text-gray-700 max-w-2xl mx-auto">
            Most organizations are paying for 3-5x more security and productivity tools than they actually need, 
            while leaving powerful features unused in their existing Microsoft 365 subscriptions.
          </p>
        </div>
      </Container>
    </section>
  );
};